// eslint-disable-next-line no-unused-vars, import/default
// We need to set the app prefix before doing anything else, so it applies to styles too.
import './webpack-entry';

import Immutable from 'immutable';
import { PluginManifest, PluginStore } from 'graylog-web-plugin/plugin';

import archiveBindings from 'archive/bindings';
import auditlogBindings from 'auditlog/bindings';
import customizationBindings from 'customization/bindings';
import failureBindings from 'failure/bindings';
import forwarderBindings from 'forwarder/bindings';
import illuminateBindings from 'illuminate/bindings';
import licenseBindings from 'license/bindings';
import reportBindings from 'report/bindings';
import lookupBindings from 'lookup/bindings';
import logViewBindings from 'logview/bindings';
import securityBindings from 'security/bindings';
import externalValueActionsBindings from 'security-content/bindings.externalValueActions';
import authenticationBindings from 'authentication/bindings';
import parameterBindings from 'enterprise/parameters/ParameterBindings';
import eventCorrelationBindings from 'event-correlation/bindings';

import watchlistBindings from './watchlist/bindings';
import enterpriseMenuBindings from './EnterpriseMenuBindings';
import exportBindings from './search/exportBindings';
import messageTableBindings from './search/bindings.messageTable';

import packageJson from '../../package.json';

const merger = (oldVal, newVal) => oldVal.concat(newVal);
const bindings = Immutable.Map().mergeWith(
  merger,
  archiveBindings,
  auditlogBindings,
  authenticationBindings,
  customizationBindings,
  enterpriseMenuBindings,
  eventCorrelationBindings,
  exportBindings,
  externalValueActionsBindings,
  failureBindings,
  forwarderBindings,
  illuminateBindings,
  licenseBindings,
  logViewBindings,
  lookupBindings,
  messageTableBindings,
  parameterBindings,
  reportBindings,
  securityBindings,
  watchlistBindings,
);
const manifest = new PluginManifest(packageJson, bindings.toJS());

PluginStore.register(manifest);
